import React , {useState} from 'react';
// import './Contact.css';
import { Link } from 'react-router-dom';
  

const Contact = () => {

  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "7290f061-a9c6-46bc-ae2b-06aae6f8f4b8");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully, One of the recruiters will reach out to you");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };



    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        companyName: "",
        message: "",
        agreed: false,
      });
    
      const [errors, setErrors] = useState({
        name: "",
        email: "",
        phone: "",
        companyName: "",
        message: "",
        agreed: "",
      });
    
      const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
          ...formData,
          [name]: type === "checkbox" ? checked : value,
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        let formErrors = { ...errors };
    
        // Name Validation
        if (!formData.name) {
          formErrors.name = "Name is required.";
        } else {
          formErrors.name = "";
        }
    
        // Email Validation
        if (!formData.email) {
          formErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
          formErrors.email = "Please enter a valid email.";
        } else {
          formErrors.email = "";
        }
    
        // Phone Validation
        if (!formData.phone) {
          formErrors.phone = "Phone number is required.";
        } else if (!/^\d+$/.test(formData.phone)) {
          formErrors.phone = "Please enter a valid phone number.";
        } else {
          formErrors.phone = "";
        }
    
        // Company Name Validation
        if (!formData.companyName) {
          formErrors.companyName = "Company name is required.";
        } else {
          formErrors.companyName = "";
        }
    
        // Message Validation
        if (!formData.message) {
          formErrors.message = "Message is required.";
        } else {
          formErrors.message = "";
        }
    
        // Privacy Policy Validation
        if (!formData.agreed) {
          formErrors.agreed = "You must agree to the privacy policy.";
        } else {
          formErrors.agreed = "";
        }
    
        setErrors(formErrors);
    
        // If there are no errors, submit the form
        if (Object.values(formErrors).every((err) => err === "")) {
          // Handle successful form submission (e.g., send data to an API or show a success message)
          console.log("Form submitted successfully!, One of the recruiters will reach out to you");
        }
      };
  return (
    <>
    <div className="contact-container">
      {/* Background Ovals */}
      {/* <div className="oval oval-top"></div>
      <div className="oval oval-bottom"></div> */}

      {/* Content */}
      <div className="content">
        <h1 className="logo-text" data-aos="fade-down" data-aos-easing="linear"
     data-aos-duration="1500">Transform Your Business <br /> with us</h1>
        <h3 className="main-text">
          {/* <span className="highlight-orange" data-aos="fade-zoom-in"
     data-aos-easing="ease-in-back"
     data-aos-delay="300"
     data-aos-offset="0">Shaping Progress, Creating Possibilities</span> */}
       
          <p  data-aos="fade-up"
     data-aos-duration="3000">Work with us to find innovative solutions for your business challenges. Our global team will guide your digital transformation, ensuring success in a fast-changing digital world.</p>
          {/* <span className="highlight-blue">Collaborate with Cognifyar Technologies to discover tailored, innovative solutions that address your unique business challenges. Our expert global team is committed to guiding your digital transformation, ensuring your success in a rapidly evolving digital landscape.</span> */}
        </h3>
        <a href="/Form-container"><button className="shadow-rotating-button">
          Join Us <span>↗</span>
        </button></a>
      </div>
    </div>
    <div className='form-page'>
    <h1>Share Your Details</h1>
    <h2>Start Your Transformation with Cognifyar Technologies</h2>
    </div>
    <div className="Form-container">
        
      <form className="contact-form" onSubmit={onSubmit} data-aos="zoom-out"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000">
        <h2 className="form-title">Contact Us Form</h2>
        
        <div className="input-group">
          <div className="input-field">
            <label>Your Name</label>
            <input
              type="text"
              placeholder="Your Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </div>
          <div className="input-field">
            <label>Enter Email</label>
            <input
              type="email"
              placeholder="example@gmail.com"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </div><br/>
        </div>

        <div className="input-group">
          <div className="input-field">
            <label>Phone*</label>
            <input
              type="tel"
              placeholder="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              pattern="[0-9]*"
              inputMode="numeric"
              required
            />
            {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
          <div className="input-field">
            <label>Company Name</label>
            <input
              type="text"
              placeholder="Company Name"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              required
            />
            {errors.companyName && <p className="error">{errors.companyName}</p>}
          </div><br/>
        </div>

        <div className="textarea-group">
          <label>Your Message</label>
          <textarea
            placeholder="Example"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          {errors.message && <p className="error">{errors.message}</p>}
        </div>

        <div className="privacy-policy">
          <input
            type="checkbox"
            id="privacy"
            name="agreed"
            checked={formData.agreed}
            onChange={handleChange}
          />
          <label htmlFor="privacy">I agree to the privacy policy</label>
          {errors.agreed && <p className="error">{errors.agreed}</p>}
        </div>

        <button type="submit" className="send-button">
          Send Message
        </button><br/>

        <span className='result'>{result}</span>
      </form>
      
    </div>



    <div className="Resume">
      <h1>
        <span className="company-name">Cognifyar Technologies :</span>
        <br />
        <span className="main-heading">Unlock Your Potential with Us
        </span>
      </h1>
      <p className="description">
      Cognifyar Technologies is dedicated to finding visionary individuals who are passionate about shaping the future through innovation. If you're ready for a career that promotes personal growth and professional challenge, we encourage you to send us your resume.
      </p>
      <Link to='mailto:Divya@cognifiyar.com'><button className="contact-button">Send Resume</button></Link>
    </div>


    <div className="Map-section">
      <div className="contact-header">
        <h1> Where We Are?</h1>
        <p>Discover Our Office Locations</p>
      </div>
      <div className="locations">
        <div className="location">
          <h3>USA California</h3>
        
          <p>
          530 Technology Dr, Ste 277, <br />
          Irvine, CA 92618 United States
          </p>
        </div>
        <div className="location">
          <h3>Canada Toronto</h3>
          <p>
            405, The West Mall, Suite 910, <br />
            Toronto, ON - M9C 5J5 Canada
          </p>
        </div>
        <div className="location">
          <h3>Chennai Tidel Park</h3>
          <p>
            5th Floor - C Block, TIDEL Park, <br />
            4, Canal Bank Rd, Taramani, Chennai
          </p>
        </div>
        <div className="location">
          <h3>Trichy</h3>
          <p>
            Plot No 13 Bharathi Nagar, 7T <br />
            Sangiliyandapuram, Tamil Nadu, Trichy
          </p>
        </div>
      </div>
    </div>

    
</>
  );
};

export default Contact;